import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MediaWrapperDirective } from './media-wrapper/media-wrapper.directive';

@NgModule({
    declarations: [MediaWrapperDirective],
    exports: [MediaWrapperDirective],
    imports: [CommonModule]
})
export class ResponsiveWrapperModule {}
